import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import AlbaranList from "./pages/AlbaranList";
import AlbaranCreate from "./pages/AlbaranCreate";
import AlbaranEdit from "./pages/AlbaranEdit";
import AlbaranDetail from "./pages/AlbaranDetail";

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<AlbaranList />} />
            <Route path="/nuevo" element={<AlbaranCreate />} />
            <Route path="/albaran/:id" element={<AlbaranDetail />} />
            <Route path="/albaran/:id/editar" element={<AlbaranEdit />} />
          </Routes>
        </main>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
